import global from '../global'

const getProfile = global.serverUrl + '/backstage/user/profile/get'
const getAuth = global.serverUrl + '/backstage/user/auth/get'
const businessList = global.serverUrl + '/backstage/user/business/list'
const personalList = global.serverUrl + '/backstage/user/personal/list'
const dealerList = global.serverUrl + '/backstage/user/dealer/list'
export default {
  getProfile,
  getAuth,
  businessList,
  personalList,
  dealerList
}



// WEBPACK FOOTER //
// ./src/config/api/user.js